import { useEffect, useRef, useState } from "react"
import { httpsCallable } from "firebase/functions"
import { functions } from "../config"

export default function useServerClock(interval = 1000) {
  const [now, setNow] = useState(Date.now())
  const offsetRef = useRef(0)
  const timerRef = useRef(null)

  useEffect(() => {
    const syncTime = async () => {
      try {
        const getServerTime = httpsCallable(functions, "getservertime")
        const res = await getServerTime()
        const serverTime = res.data.timestamp
        const clientTime = Date.now()

        offsetRef.current = serverTime - clientTime
        setNow(serverTime)
      } catch {
        // fallback → client time
        offsetRef.current = 0
        setNow(Date.now())
      }

      // start ticking AFTER sync
      timerRef.current = setInterval(() => {
        setNow(Date.now() + offsetRef.current)
      }, interval)
    }

    syncTime()

    return () => {
      if (timerRef.current) clearInterval(timerRef.current)
    }
  }, [interval])

  return now
}
